import "./index.scss";

export const GreenIndicator = () => {
  return (
    <div className="green-indicator-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="9"
        viewBox="0 0 9 9"
        fill="none"
      >
        <path
          d="M8.34655 4.49919C8.34655 6.74024 6.52982 8.55697 4.28877 8.55697C2.04772 8.55697 0.230986 6.74024 0.230986 4.49919C0.230986 2.25814 2.04772 0.441406 4.28877 0.441406C6.52982 0.441406 8.34655 2.25814 8.34655 4.49919Z"
          fill="#71BF8F"
        />
      </svg>
    </div>
  );
};
